import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Image } from "antd";
import { FC, useCallback, useMemo, useState } from "react";

import { BaseModal } from "@/components/BaseModal";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";
import { getFileUrl } from "@/utils/file/getFileUrl";

import {
    StyledCameraPreviewOverlay,
    StyledCarousel,
    StyledImageWrapper,
    StyledProductItem,
} from "./Styled";

interface CameraPreviewOverlayProps {
    fingroup: string;
}

export const CameraPreviewOverlay: FC<CameraPreviewOverlayProps> = ({
    fingroup,
}) => {
    const { products } = useAppSelector((s) => s.offline);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const handleCloseModal = useCallback(() => {
        setIsOpenModal(false);
    }, []);

    const handleOpenModal = useCallback(() => {
        setIsOpenModal(true);
    }, []);

    const filteredProducts = useMemo(() => {
        const normalizeFingroup = fingroup.toLowerCase();

        return Object.values(products).filter((p) => {
            const values = [
                p.params.fin_group_detail.value.toLocaleLowerCase(),
                p.params.fin_group.value.toLocaleLowerCase(),
            ];

            return values.includes(normalizeFingroup);
        });
    }, [products, fingroup]);

    if (!filteredProducts.length) return null;

    return (
        <>
            <StyledCameraPreviewOverlay>
                <Button
                    type="default"
                    icon={<InfoCircleOutlined />}
                    onClick={handleOpenModal}
                >
                    <PrimaryText ellipsis>{fingroup}</PrimaryText>
                </Button>
            </StyledCameraPreviewOverlay>

            <BaseModal
                open={isOpenModal}
                onClose={handleCloseModal}
                title={`Група: ${fingroup} (${filteredProducts.length})`}
                maskClosable={true}
                actions={null}
                centered={false}
                destroyOnHidden={false}
                styles={{
                    mask: {
                        backgroundColor: "transparent",
                    },
                }}
            >
                <StyledCarousel dots={false} draggable arrows>
                    {filteredProducts.map(({ barcode, name, params }) => {
                        const photo = params.image.value[0];

                        return (
                            <StyledProductItem key={barcode}>
                                <StyledImageWrapper>
                                    <Image
                                        src={getFileUrl(photo)}
                                        alt={name}
                                        preview={false}
                                        style={{
                                            objectFit: "contain",
                                        }}
                                    />
                                </StyledImageWrapper>

                                <PrimaryText fontSize={16} textAlign="center">
                                    {name}
                                </PrimaryText>
                            </StyledProductItem>
                        );
                    })}
                </StyledCarousel>
            </BaseModal>
        </>
    );
};
